// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-NpoJY","icon_color":"icon_color-TDR5P"};